module.exports = "<div class=\"meter-gauge\"><div ng-if=\"options\" dx-circular-gauge=\"options\"></div></div>"